import React from 'react'
import { SlidesRemoveConfirmModalProps } from './types'
import WarningModal from '../WarningModal'

const SlidesRemoveConfirmModal: React.FC<SlidesRemoveConfirmModalProps> = ({ onCancel, onConfirm }) => {

  return <WarningModal
    headerText='Are you sure you want to remove slides?'
    body={<div><p>Slides will be removed for all presenters and will need to be uploaded again.</p></div>}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmationText='Yes, remove slides'
    isOpen={true}
  />

}

export default SlidesRemoveConfirmModal
